import { HTMLInputTypeAttribute } from "react";
import classNames from "classnames";
import {
  errorInput,
  input,
  errorInputWrapper,
  inputWrapper,
} from "./styles.css";

type InputProps = {
  type?: HTMLInputTypeAttribute;
  placeholder?: string;
  isError?: boolean;
  name?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Input = ({
  type = "text",
  placeholder,
  isError,
  name,
  required = false,
  disabled = false,
  className,
  value,
  onChange,
}: InputProps) => {
  return (
    <div
      className={classNames(inputWrapper, {
        [errorInputWrapper]: isError,
      })}
    >
      <input
        name={name}
        className={classNames(input, className, { [errorInput]: isError })}
        type={type}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};
